module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"YouShip","short_name":"YouShip","start_url":"/","background_color":"#EC5344","theme_color":"#EC5344","display":"minimal-ui","icon":"../shared/assets/favicon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"0a7388898840aa51a841d99c8d30b36f"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
